export default __webpack_public_path__ + "images/49_1_image.jpg";